module.exports = __webpack_public_path__ + "static/media/HubspotLogo.c34ac790.svg";